import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';

class FileManagerLayouter extends Component {
	render() {
		const { children } = this.props;
		return <div className="file-manager-layouter">{children}</div>;
	}
}

FileManagerLayouter.propTypes = {
	children: PropTypes.node.isRequired
};

export default FileManagerLayouter;
